import { useI18n } from 'vue-i18n';
import { ref } from 'vue';

export function useLanguage() {
	const { locale } = useI18n();
	const currentLanguage = ref(locale.value);

	const availableLanguages = [
		{ code: 'id', name: 'Bahasa Indonesia' },
		{ code: 'en', name: 'English' },
	];

	const setLanguage = (lang) => {
		locale.value = lang;
		currentLanguage.value = lang;
		localStorage.setItem('language', lang);
	};

	const getLanguageName = (code) => {
		const lang = availableLanguages.find((l) => l.code === code);
		return lang ? lang.name : code;
	};

	return {
		currentLanguage,
		availableLanguages,
		setLanguage,
		getLanguageName,
	};
}
